import { Injectable } from '@angular/core';
import * as FingerprintJS from '@fingerprintjs/fingerprintjs';

@Injectable({
  providedIn: 'root'
})
export class FingerprintService {

  private fpPromise: Promise<any>;

  constructor() {
    // Initialize the FingerprintJS agent
    this.fpPromise = FingerprintJS.load();
  }

  async getFingerprint(): Promise<string> {
    const fp = await this.fpPromise;
    const result = await fp.get();
    return result.visitorId; // This is the unique identifier
  }
}